import React from 'react';
import { HStack, Stack, Text } from '@adc/parallax-component-library';
export const ListItem = ({ children, fontToken, testID }) => {
    if (!children?.length) {
        return null;
    }
    const textChildren = children.filter((child) => typeof child === 'string' || child.type === Text);
    const restChildren = children.filter((child) => typeof child !== 'string' && child.type !== Text);
    return (React.createElement(Stack, { tag: "li", style: { display: 'list-item' }, testID: testID, nativeID: testID },
        React.createElement(HStack, null,
            React.createElement(Text, { type: fontToken, flexShrink: 1, testID: `${testID}-text`, nativeID: `${testID}-text` }, textChildren)),
        React.createElement(Stack, { marginLeft: "$2" }, restChildren)));
};
ListItem.displayName = 'ListItem';
export const List = ({ children, listType = 'ul', testID }) => {
    return (React.createElement(Stack, { tag: listType, paddingInlineStart: "$6", marginInlineStart: 0, marginInlineEnd: 0, marginBlockStart: "$2", marginBlockEnd: "$2", justifyContent: "center", style: { listStyleType: listType === 'ol' ? 'decimal' : 'disc' }, testID: testID, nativeID: testID }, children));
};
